'use strict';

var internalLinkDestinations = {
  activity: {
    detail: '/v/activity/{{suffix:0}}/detail',
    details: '/v/activity/{{suffix:0}}/detail',
    intro: '/v/activity/{{suffix:0}}/intro',
    suffix: '/v/activity/{{suffix:0}}/{{suffix:1}}'
  },
  assessment: '/login/assessment',
  coaching: '/v/?openCoaching=true',
  contact: 'https://mystrength.com/contact',
  gethelp: '/v/help',
  history: {
    options: {
      activity: '/v/history',
      assessment: '/v/assessments'
    }
  },
  home: '/v/',
  inspiration: {
    core: '/v/inspiration/inspiration:{{suffix:0}}'
  },
  inspirations: {
    options: {
      new: '/v/inspirations/new',
      popular: '/v/inspirations',
      favorites: '/v/inspirations/my',
      me: '/v/inspirations/manage',
      upload: '/v/inspirations/upload'
    }
  },
  program: '/v/program/{{suffix:0}}',
  search: {
    noSuffix: '/v/browse',
    suffix: '/v/browse/results/{{suffix:0}}'
  },
  settings: {
    options: {
      index: '/v/settings',
      profile: '/v/settings',
      personalization: '/v/settings/customization'
    }
  },
  tools: {
    options: {
      index: '/v/tools',
      trackers: '/v/tracker/chart',
      goals: '/v/goals',
      sleep_plan: '/v/sleep/plan',
      sleep_diary: '/v/sleep/diary',
      sleep: '/v/sleep/diary',
      sleep_entry: '/v/sleep/entry'
    }
  },
  browse: {
    core: '/v/browse/{{suffix:0}}'
  }

};

(function () {
  'use strict';

  angular.module('vnext').factory('internalLinkSvc', internalLinkSvc);

  internalLinkSvc.$inject = ['$log'];

  /* @ngInject */
  function internalLinkSvc($log) {

    return {
      getInternalLink: getInternalLink
    };

    function getInternalLink(destination) {
      return _buildInternalLink(destination);
    }

    function _buildInternalLink(destination) {
      var internalLinkArray = destination.split(':');
      var linkBase = internalLinkArray[0];
      var linkSuffixes = internalLinkArray.slice(1);
      var internalLink = null;
      var destinationHasOptions = internalLinkDestinations[linkBase] && typeof internalLinkDestinations[linkBase]['options'] !== 'undefined';

      if (typeof internalLinkDestinations[linkBase] === 'undefined') {
        $log.warn('Invalid internal link base: ' + linkBase);
        return internalLink;
      }

      if (destinationHasOptions) {
        internalLink = _buildLinkWithOptions(linkBase, linkSuffixes);
      } else if (linkBase === 'search') {
        internalLink = _buildSearchLink(linkBase, linkSuffixes);
      } else if (linkBase === 'activity') {
        internalLink = _buildActivityLink(linkBase, linkSuffixes);
      } else if (linkBase === 'inspiration') {
        internalLink = _buildInspirationLink(linkBase, linkSuffixes);
      } else if (linkBase === 'browse') {
        internalLink = _buildBrowseLink(linkBase, linkSuffixes);
      } else {
        internalLink = _buildPlainLink(linkBase, linkSuffixes);
      }
      return internalLink;
    }

    function _buildLinkWithOptions(linkBase, linkSuffixes) {
      if (linkSuffixes.length > 0) {
        if (linkBase === 'tools' && linkSuffixes[0] === 'sleep_entry') {
          var date = new Date();
          date.setDate(date.getDate() - 1);
          return internalLinkDestinations[linkBase]['options'][linkSuffixes[0]] + '?day=' + date.toISOString().split('T')[0];
        }
        return internalLinkDestinations[linkBase]['options'][linkSuffixes[0]];
      } else {
        return internalLinkDestinations[linkBase]['options']['index'];
      }
    }

    function _buildPlainLink(linkBase, linkSuffixes) {
      var linkUrlTemplate = internalLinkDestinations[linkBase];

      if (!_urlTemplateHasToken(linkUrlTemplate)) {
        return linkUrlTemplate;
      } else {
        return linkSuffixes.reduce(function (acc, suffix, index) {
          var token = 'suffix:' + index;
          return _replaceUrlToken(acc, token, suffix);
        }, linkUrlTemplate);
      }
    }

    function _replaceUrlToken(url, token, replacement) {
      return url.replace('{{' + token + '}}', replacement);
    }

    function _urlTemplateHasToken(url) {
      var tokenRegex = new RegExp('[{]{2}suffix:[0-9][}]{2}', 'gm');
      return tokenRegex.test(url);
    }

    function _buildSearchLink(linkBase, linkSuffixes) {
      if (linkSuffixes.length > 0) {
        return _replaceUrlToken(internalLinkDestinations[linkBase]['suffix'], 'suffix:0', linkSuffixes[0]);
      } else {
        return internalLinkDestinations[linkBase]['noSuffix'];
      }
    }

    function _buildActivityLink(linkBase, linkSuffixes) {
      if (linkSuffixes.length > 1) {
        var linkUrlTemplate = internalLinkDestinations[linkBase][linkSuffixes[1]] ? internalLinkDestinations[linkBase][linkSuffixes[1]] : internalLinkDestinations[linkBase]["suffix"];
        return linkSuffixes.reduce(function (acc, suffix, index) {
          var token = 'suffix:' + index;
          return _replaceUrlToken(acc, token, suffix);
        }, linkUrlTemplate);
      } else {
        return _replaceUrlToken(internalLinkDestinations[linkBase]['intro'], 'suffix:0', linkSuffixes[0]);
      }
    }

    function _buildInspirationLink(linkBase, linkSuffixes) {
      return _replaceUrlToken(internalLinkDestinations[linkBase]['core'], 'suffix:0', linkSuffixes[0]);
    }

    function _buildBrowseLink(linkBase, linkSuffixes) {
      return _replaceUrlToken(internalLinkDestinations[linkBase]['core'], 'suffix:0', linkSuffixes[0]);
    }
  }
})();